<div class="flex flex-col h-full w-full justify-start items-start bg-[#FFFFFF] overflow-y-auto">
    <app-quality-stepper [isCheckView]="true" [selectedStep]="2" class="w-full"></app-quality-stepper>

    <app-loading-screen class="w-full flex-1"
                        [checkName]="'All-Right Check'"
                        [loadingText]="'Wir überprüfen Ihre Projektdaten.'"
                        [loadingMessages]="['Anforderungen werden analysiert...',
                                            'Dateien werden analysiert...',
                                            'Anforderungen werden geprüft...',
                                            'Dateien werden geprüft...',
                                            'Ergebnisse werden zusammengestellt...',
                                            'Ergebnisbericht wird geladen...']"
    ></app-loading-screen>

    <call-to-action-banner class="w-full"
                           [title]="'Sind Ihre Planungsunterlagen nach HOAI vollständig?'"
                           [descr]="'Jetzt den HOAI-Check ausprobieren und die Vollständigkeit der Planungsunterlagen nach HOAI-Anforderungen überprüfen lassen.'"
                           [button]="'HOAI'">
    </call-to-action-banner>


</div>
